import 'owl.carousel';

if (typeof $.fn.owlCarousel === 'function') {
  $.fn.owlCarousel.Constructor.Plugins.Navigation.Defaults.navText = [
    '<svg class="c-icon c-icon-svg c-icon-svg-arrow-left">'
    + '<use xlink:href="/assets/images/icons.svg#arrow-left"></use></svg>',
    '<svg class="c-icon c-icon-svg c-icon-svg-arrow-right">'
    + '<use xlink:href="/assets/images/icons.svg#arrow-right"></use></svg>',
  ];
}
